import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { CELL_SIZE } from "src/grid/constants";
import { instructions, InstructionType } from "src/program/instructionData";
import { useProgram } from "src/program/ProgramContext";

export const Palette = observer(function Palette() {
  const program = useProgram();

  return (
    <div>
      <h2>Palette</h2>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {instructions.map((instruction) => {
          return (
            <div
              key={instruction.type}
              style={{
                width: `${CELL_SIZE}px`,
                height: `${CELL_SIZE}px`,
                border:
                  program.selectedPaletteInstruction === instruction.type
                    ? "1px solid black"
                    : "1px solid transparent",
                cursor: "pointer",
              }}
              onClick={() =>
                (program.selectedPaletteInstruction = instruction.type)
              }
            >
              {instruction.toString()}
            </div>
          );
        })}
      </div>
    </div>
  );
});
